import {hashCodeCertificate} from "./hoc/hashCodeCertificate";
import {modalCommentLink} from "./hoc/modalCommentLink";

const WaybillV2ResponsiblePersonReject = modalCommentLink('WaybillV2ResponsiblePersonReject')

export default WaybillV2ResponsiblePersonReject


